import { render, staticRenderFns } from "./DetailMessageSent.vue?vue&type=template&id=366917ec&"
import script from "./DetailMessageSent.vue?vue&type=script&lang=js&"
export * from "./DetailMessageSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports